"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (barrier, entrySpot, lastTickQuote) {
    return +barrier + (+entrySpot || lastTickQuote);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/barrier/commonRelativeBarrier.js
// module id = 6
// module chunks = 0